import React, { useEffect, useCallback } from 'react';
import './MerchantStoreMenuDrawer.css';

function MerchantStoreMenuDrawer({ isOpen, onClose, onEditStore, onViewDashboard }) {
  // ESC to close
  const handleKeyDown = useCallback((e) => { if (e.key === 'Escape') onClose?.(); }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;
    document.addEventListener('keydown', handleKeyDown);
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = original;
    };
  }, [isOpen, handleKeyDown]);

  return (
    <>
      <div
        className={`msd-backdrop ${isOpen ? 'msd-backdrop--show' : ''}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />
      <aside
        className={`msd-sheet ${isOpen ? 'msd-sheet--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Store menu"
      >
        <div className="msd-grabber" />
        <div className="msd-header">
          <h3 className="msd-title">Store</h3>
          <button className="msd-close" onClick={onClose} aria-label="Close menu">✕</button>
        </div>

        <div className="msd-list" role="menu">
          <button
            className="msd-item"
            role="menuitem"
            onClick={() => { onClose?.(); setTimeout(() => onEditStore?.(), 0); }}
          >
            <span className="msd-label">Edit Store</span>
          </button>

          <button
            className="msd-item"
            role="menuitem"
            onClick={() => { onClose?.(); setTimeout(() => onViewDashboard?.(), 0); }}
          >
            <span className="msd-label">View Dashboard</span>
          </button>
        </div>

        <div className="msd-safearea" />
      </aside>
    </>
  );
}

export default MerchantStoreMenuDrawer;
